import qs from 'querystringify'
import remote from './remote'

const URL = {
    SEARCH_LOG: '/cms/system/statistic',
}

export default {
  searchStatistic (option) {
      let url = remote.getUrl(URL.SEARCH_LOG)

      if (option) {
          url = url + '?' + qs.stringify(option)
      }

      return remote.request({
          url: url,
      })
  }
}
